<template>
  <div class="enterUserRegistration">
    <h1>Input the UserInfo data</h1>
    <input type="text" v-model="userFirst" placeholder="First Name" />
    <input type="text" v-model="userLast" placeholder="Last Name" />
    <input type="text" v-model="email" placeholder="Email" />
    <input type="text" v-model="phone1" placeholder="Primary Phone Number" />
    <input type="text" v-model="phone2" placeholder="Secondary Phone Number" />
    <input type="text" v-model="address1" placeholder="Address Line 1" />
    <input type="text" v-model="address2" placeholder="Address Line 2" />
    <input type="text" v-model="address3" placeholder="Address Line3" />
    <input type="text" v-model="City" placeholder="City" />
    <input type="text" v-model="state" placeholder="State" />
    <input type="text" v-model="zip" placeholder="Zip" />
    <input type="text" v-model="zip4" placeholder="Zip4" />
    <input type="text" v-model="country" placeholder="Country" />
    <button v-on:click="createUserInfo">Save</button>
  </div>
</template>

<script>
import { API } from "aws-amplify";
import { createUserInfo } from "@/graphql/mutations";

export default {
  name: "enterUserRegistration",
  data() {
    return {
      userFirst: "",
      userLast: "",
      email: "",
      phone1: "",
      phone2: "",
      address1: "",
      address2: "",
      address3: "",
      City: "",
      state: "",
      zip: "",
      zip4: "",
      country: "",
      activeUser: "",
      premiumUser: ""
    };
  },
  methods: {
    async createUserInfo() {
      const {
        userFirst,
        userLast,
        email,
        phone1,
        phone2,
        address1,
        address2,
        address3,
        City,
        state,
        zip,
        zip4,
        country,
        activeUser,
        premiumUser
      } = this;
      if (!userFirst || !userLast) return;
      const userInfo = {
        userFirst,
        userLast,
        email,
        phone1,
        phone2,
        address1,
        address2,
        address3,
        City,
        state,
        zip,
        zip4,
        country,
        activeUser,
        premiumUser
      };
      await API.graphql({
        query: createUserInfo,
        variables: { input: userInfo }
      });
      this.userFirst = "";
      this.userLast = "";
      this.email = "";
      this.phone1 = "";
      this.phone2 = "";
      this.address1 = "";
      this.address2 = "";
      this.address3 = "";
      this.City = "";
      this.state = "";
      this.zip = "";
      this.zip4 = "";
      this.country = "";
      this.activeUser = true;
      this.premiumUser = false;
    }
  }
};
</script>
